export default __webpack_public_path__ + "static/alaaeddine-a873f8b942e9006d50c8a718b93c48ba.jpg";